import { BOOK_SECTIONS } from './booksCategorySchema';

/**
 * Shop-by-department tree used by the search category dropdown.
 * Keys are display labels; `categoryValue` is the API/filter value when it differs.
 */
export const SIDE_MENU_CATEGORIES = {
  'Computers & Electronics': {
    categoryValue: 'Computers & Electronics',
    subcategories: [
      'Mobile Phones',
      'Computer Accessories & Peripherals',
      'Computer Components',
      'Computers & Tablets',
      'Data Storage',
      'External Components',
      'Laptop Accessories',
      'Monitors',
      'Networking Products',
      'Power Strips & Surge Protectors',
      'Printers',
      'Scanners',
      'Servers',
      'Tablet Accessories',
      'Tablet Replacement Parts',
      'Warranties & Services',
    ],
  },
  'Toys & Video Games': {
    categoryValue: 'Toys & Video Games',
    subcategoryParam: 'subcategory',
    subcategories: [
      'Action Figures & Statues',
      'Arts & Crafts',
      'Baby & Toddler Toys',
      'Building Toys',
      'Dolls & Accessories',
      'Dress Up & Pretend Play',
      'Games',
      'Grown-Up Toys',
      'Hobbies',
      "Kids' Furniture, Décor & Storage",
      'Learning & Education',
      'Novelty & Gag Toys',
      'Party Supplies',
      'Puppets',
      'Puzzles',
      'Sports & Outdoor Play',
      'Stuffed Animals & Plush Toys',
      'Toy Remote Control & Play Vehicles',
      'Tricycles, Scooters & Wagons',
      'Video Games',
      'PlayStation 4',
      'PlayStation 3',
      'Xbox One',
      'Xbox 360',
      'Nintendo Switch',
      'Wii U',
      'Wii',
      'PC',
      'Mac',
      'Nintendo 3DS & 2DS',
      'Nintendo DS',
      'PlayStation Vita',
      'Sony PSP',
      'Retro Gaming & Microconsoles',
      'Accessories',
      'Digital Games',
      'Kids & Family',
    ],
  },
  'Arts & Crafts': {
    subcategories: [
      'Painting, Drawing & Art Supplies',
      'Beading & Jewelry Making',
      'Crafting',
      'Fabric',
      'Fabric Decorating',
      'Knitting & Crochet',
      'Needlework',
      'Organization, Storage & Transport',
      'Printmaking',
      'Scrapbooking & Stamping',
      'Sewing',
      'Party Decorations & Supplies',
      'Gift Wrapping Supplies',
    ],
  },
  Automotive: {
    subcategories: [
      'Car Care',
      'Exterior Accessories',
      'Interior Accessories',
      'Lights & Lighting Accessories',
      'Motorcycle & Powersports',
      'Oils & Fluids',
      'Paint & Paint Supplies',
      'Performance Parts & Accessories',
      'Replacement Parts',
      'RV Parts & Accessories',
      'Tires & Wheels',
      'Tools & Equipment',
      'Automotive Enthusiast Merchandise',
      'Heavy Duty & Commercial Vehicle Equipment',
      'Amazon Autos',
    ],
  },
  Baby: {
    subcategories: [
      'Activity & Entertainment',
      'Baby & Toddler Toys',
      'Baby Care',
      'Baby Stationery',
      'Car Seats & Accessories',
      'Diapering',
      'Feeding',
      'Gifts',
      'Nursery',
      'Potty Training',
      'Pregnancy & Maternity',
      'Safety',
      'Strollers & Accessories',
      'Travel Gear',
    ],
  },
  'Beauty and Personal Care': {
    subcategories: [
      'Makeup',
      'Skin Care',
      'Hair Care',
      'Fragrance',
      'Foot, Hand & Nail Care',
      'Tools & Accessories',
      'Shave & Hair Removal',
      'Personal Care',
      'Oral Care',
    ],
  },
  Clothing: {
    categoryValue: 'Clothing',
    subcategoryParam: 'subcategory',
    subcategories: ['Men', 'Women', 'Kids', 'Babies'],
  },
  Accessories: {
    categoryValue: 'Accessories',
    subcategoryParam: 'subcategory',
    subcategories: ['Men', 'Women', 'Kids'],
  },
  Footwear: {
    categoryValue: 'Footwear',
    subcategoryParam: 'subcategory',
    subcategories: ['Men', 'Women', 'Kids'],
  },
  Bags: {
    categoryValue: 'Bags',
    subcategoryParam: 'subcategory',
    subcategories: ['Men', 'Women', 'Kids'],
  },
  Watches: {
    categoryValue: 'Watches',
    subcategoryParam: 'subcategory',
    subcategories: ['Analog', 'Digital', 'Smartwatch', 'Sport', 'Other'],
  },
  'Home and Kitchen': {
    categoryValue: 'Home & Kitchen',
    subcategoryParam: 'subcategory',
    subcategories: [
      "Kids' Home Store",
      'Kitchen & Dining',
      'Bedding',
      'Bath',
      'Furniture',
      'Home Décor',
      'Wall Art',
      'Lighting & Ceiling Fans',
      'Seasonal Décor',
      'Event & Party Supplies',
      'Heating, Cooling & Air Quality',
      'Irons & Steamers',
      'Vacuums & Floor Care',
      'Storage & Organization',
      'Cleaning Supplies',
    ],
  },
  Books: {
    categoryValue: 'Books',
    subcategoryParam: 'book_subcategory',
    subcategories: BOOK_SECTIONS,
  },
  Stationary: {
    categoryValue: 'Stationary',
    subcategories: [
      'Notebooks & Journals',
      'Pens & Pencils',
      'Art Supplies',
      'School Supplies',
      'Office Supplies',
      'Planners & Calendars',
      'Files & Folders',
      'Calculators',
      'Desk Accessories',
    ],
  },
  'Musical Instruments': {
    categoryValue: 'Musical Instruments',
    subcategories: [
      'Guitars & Basses',
      'Keyboards & Pianos',
      'Drums & Percussion',
      'Wind & Brass',
      'String Instruments',
      'DJ & Recording Equipment',
      'Amplifiers & Effects',
      'Accessories & Parts',
    ],
  },
  Luggage: {
    subcategories: [
      'Carry-ons',
      'Backpacks',
      'Garment bags',
      'Travel Totes',
      'Luggage Sets',
      'Laptop Bags',
      'Suitcases',
      'Kids Luggage',
      'Messenger Bags',
      'Umbrellas',
      'Duffles',
      'Travel Accessories',
    ],
  },
  'Pet supplies': {
    categoryValue: 'Pet Supplies',
    subcategoryParam: 'subcategory',
    subcategories: [
      'Beds & Furniture',
      'Carriers & Travel',
      'Collars, Harnesses & Leashes',
      'Feeding Supplies',
      'Toys',
      'Litter & Waste Management',
      'Cages, Aquariums & Habitats',
      'Grooming Equipment',
      'Training Accessories',
      'Pet Clothing',
      'Pet Accessories',
      'Pet Technology',
      'Other Pet Supplies',
    ],
  },
  'Sports and Outdoors': {
    subcategories: [
      'Sports and Outdoors',
      'Outdoor Recreation',
      'Sports & Fitness',
    ],
  },
  'Tools & Home Improvement': {
    subcategories: [
      'Tools & Home Improvement',
      'Appliances',
      'Building Supplies',
      'Kitchen & Bath Fixtures',
      'Light Bulbs',
      'Lighting & Ceiling Fans',
      'Measuring & Layout Tools',
      'Painting Supplies & Wall Treatments',
      'Power & Hand Tools',
      'Rough Plumbing',
      'Safety & Security',
      'Welding & Soldering',
    ],
  },
};

const SEP = '::';

/** Encode main (+ optional sub) for <select> values. */
export function encodeSearchCategory(categoryValue, subCategory = '') {
  if (!categoryValue) return '';
  return subCategory ? `${categoryValue}${SEP}${subCategory}` : categoryValue;
}

/** Decode <select> value → { categoryValue, subCategory, config }. */
export function decodeSearchCategory(encoded) {
  if (!encoded) {
    return { categoryValue: '', subCategory: '', config: {} };
  }
  const [categoryValue, ...rest] = String(encoded).split(SEP);
  const subCategory = rest.join(SEP);
  const entry =
    Object.entries(SIDE_MENU_CATEGORIES).find(
      ([key, cfg]) => (cfg.categoryValue || key) === categoryValue,
    ) || null;
  const config = entry ? entry[1] : {};
  return {
    categoryValue,
    subCategory,
    config,
    label: entry ? entry[0] : categoryValue,
  };
}

/**
 * Flat options for the search category dropdown (All + each main category).
 * Main categories only — same departments as Men/Women/Kids/Babies browse.
 */
export function getSearchCategoryOptions() {
  return Object.entries(SIDE_MENU_CATEGORIES).map(([label, cfg]) => ({
    label,
    value: encodeSearchCategory(cfg.categoryValue || label),
    categoryValue: cfg.categoryValue || label,
  }));
}
